export default "__VITE_ASSET__CU2q_hV5__"